import { ApiError } from './api-error';

export class BadGatewayError extends ApiError {}
